/**
 * AuthUserEvents
 * Registry of events for the Auth pages
 */
export enum AuthUserEvents {
    Logout = "Auth - Logout Link Click",
    LoginLinkClickGoogle = "Auth - Login Link Click - Google",
    LoginLinkClickLinkedIn = "Auth - Login Link Click - LinkedIn",
    LoginLinkClickMicrosoft = "Auth - Login Link Click - Microsoft",
    EmailLogin = "Auth - Email Login",
    InlineEmailLogin = "Auth - Inline Email Login",
    EmailLoginResponseUndefined = "Auth - Email Login - Response Undefined",
    InlineEmailLoginResponseUndefined = "Auth - Inline Email Login - Response Undefined",
    EmailLoginResponseOkFalse = "Auth - Email Login - Response.ok = false",
    InlineEmailLoginResponseOkFalse = "Auth - Inline Email Login - Response.ok = false",
    EmailLoginSuccess = "Auth - Email Login - Success",
    InlineEmailLoginSuccess = "Auth - Inline Email Login - Success",
    OTPResponseUndefined = "Auth - OTP Login - Response Undefined",
    InlineOTPResponseUndefined = "Auth - Inline OTP Login - Response Undefined",
    OTPResponseOkFalse = "Auth - OTP Login - Response.ok = false",
    InlineOTPResponseOkFalse = "Auth - Inline OTP Login - Response.ok = false",
    OTPResponseStatusNot200 = "Auth - OTP Login - Response.status != 200",
    InlineOTPResponseStatusNot200 = "Auth - Inline OTP Login - Response.status != 200",
    OTPResponseUrlIncludesAuthError = "Auth - OTP Login - Response.url includes /auth/error",
    InlineOTPResponseUrlIncludesAuthError = "Auth - Inline OTP Login - Response.url includes /auth/error",
    OTPSuccess = "Auth - OTP Login - Success",
    InlineAuthenticationModalOpen = "Auth - Inline Authentication Modal Open",
    InlineOnboardingModalOpen = "Auth - Inline Onboarding Modal Open",
    InlineRegistrationModalOpen = "Auth - Inline Registration Modal Open",
    InvitationAccept = "Auth - Invitation Accept",
    InvitationReject = "Auth - Invitation Reject",
    VerifyEmailBackLinkClick = "Auth - Verify Email - Back Link Click",
    InlineAuthenticationModalSignInLinkClick = "Auth - Inline Authentication Modal - Sign in link click",
    LoginPageRegisterLinkClick = "Auth - Login Page - Register Link Click",
    RegisterPageLoginLinkClick = "Auth - Register Page - Login Link Click",
    RegisterPageContinueWhenSignedIn = "Auth - Register Page - Continue When Signed In",
    LoginPageContinueWhenSignedIn = "Auth - Login Page - Continue When Signed In",
    RegisterLinkClickGoogle = "Auth - Register Link Click - Google",
    InlineRegisterLinkClickGoogle = "Auth - Inline Register Link Click - Google",
    EmailRegister = "Auth - Email Register",
    EmailRegisterResponseUndefined = "Auth - Email Register - Response Undefined",
    EmailRegisterResponseOkFalse = "Auth - Email Register - Response.ok = false",
    EmailRegisterSuccess = "Auth - Email Register - Success",
}

export enum AuthApiEvents {
    SignIn = "Auth API - Sign In",
    Register = "Auth API - Register",
}
